import { TAG_URL } from 'lib/urls';

import * as S from './styles';

interface ITag {
  tag: {
    name?: string;
    slug: string;
  };
}

const Tag = ({ tag }: ITag) => {
  return <S.StyledLink href={TAG_URL({ slug: tag.slug })}>{tag.name}</S.StyledLink>;
};

export default Tag;
